/**
 *  서버 피처 플래그 페이지명 (백엔드 AMZBM-136)
 */
export const FEATURE_FLAG_PAGE_NAME = {
  MAIN: '서버 피처 플래그',
};
